/*
 * @Author: Gaho
 * @Date: 2023-12-29 14:36:37
 * @LastEditors: Gaho
 * @LastEditTime: 2023-12-29 14:36:57
 */
const s = {
    ballDistance: 18,
    diameter: 7,
    numRows: 16,
    ballProp: {
        mass: 1.1,
        densety: .9,
        friction: {
            x: .97,
            y: .93
        }
    },
    xps: {
        0: [352.52624234472785, 329.44295666558367, 352.54368664453136, 354.7058074216211, 352.75436668977704, 327.19685203435984],
        1: [329.02755346147956, 354.60451758343606, 353.5847368975735, 352.0475498882167, 328.85868734296525, 351.886114016525, 352.753516738531, 351.50086491949037],
        2: [329.26166191308164, 327.8709620754507, 328.7678150192257, 329.41408371336007, 328.843865305664, 352.48231854743125, 330.06697875161836, 327.3520866515783],
        3: [328.19110433108324, 329.9577760988873, 327.98619855825797, 353.511460647861, 352.5097003358686, 327.7679738496197, 352.42958496370846, 352.51436887783166],
        4: [328.7521146558679, 329.21296635453194, 352.86644534702145, 352.7305288381863, 354.2673881413909, 328.6422958200444, 354.2896917850799, 327.769506903137],
        5: [329.01544015220577, 352.08129951721514, 354.2155090441193, 328.54038447199065, 328.8550002247199, 352.80132869493457, 353.8068724234832, 329.783804447538],
        6: [330.02803925177705, 328.87352433922234, 329.8159831195464, 354.42437965632234, 327.5403411277221, 328.2196048794014, 352.58613573492676, 353.35400616595393],
        7: [351.9787572824372, 354.67067238920635, 353.9447379832694, 328.2631940524317, 329.2620763583507, 353.7666102499642, 351.54858984480524, 353.91606339375346],
        8: [353.70239762988666, 352.7259393508031, 352.2102977760028, 352.4946245608316, 354.47706162480574, 327.34596041572297, 351.84147779546737, 330.2565945282315],
        9: [352.950403249869, 328.12577125178024, 352.33243435657175, 353.59720592853904, 329.6680520428811, 352.92198402000815, 328.4862186820727, 327.75101994431714],
        10: [353.70893406898944, 354.6213232730548, 354.50068567547373, 353.7475307785072, 327.40212043645784, 330.23517213629094, 328.3253516359087, 329.79883129024466],
        11: [328.63879001332276, 354.39426520659515, 329.33392136201354, 329.37314074167455, 328.17419567406114, 351.83998048711584, 327.93667266120366, 328.17277356204835],
        12: [352.86578016658854, 353.2076623775722, 327.37346862702356, 327.3664084192777, 351.54110305922813, 329.9744428072235, 329.8435016717254, 353.1730190449227],
        13: [328.3744392146186, 351.84793439200746, 353.1756739630466, 353.23472433461455, 327.85168358740503, 329.67529825178843, 328.3613685372937, 330.2356210790805],
        14: [353.69187453409313, 328.2144810812275, 354.37140567898757, 352.8807902591559, 353.19657930145996, 328.0947276491498, 354.12153912722886, 353.12223458934926],
        15: [352.7271562081545, 329.9233515346407, 327.8895744097779, 329.58257257292684, 329.9188020727569, 353.22150023360007, 328.39423079002603, 330.201653795131],
        16: [328.70497294472506],
        17: []
    }
};
export {s as default};
